import type { Router } from "vue-router";

import { getRepoData } from "@/js/githubClient";
import { sdk } from "@/js/sdk";
import { SdkError, ERROR_CODES } from "@signaloid/cloud-compute-engine-client";
import { monitoringCaptureError } from "@/plugins/monitoring";

export async function isRepositoryConnected(remoteURL: URL): Promise<boolean> {
	const fullName = remoteURL.pathname.replace(/^\/|\/$/g, "").replace(/\.git$/, "");
	let branch: string;
	try {
		const response = await getRepoData(fullName);
		branch = response.data.default_branch;
	} catch {
		return false;
	}

	try {
		const result = await sdk.repositories.lookup({ RemoteURL: remoteURL.href, Branch: branch });
		return result !== null;
	} catch (error) {
		if (error instanceof SdkError && error.code !== ERROR_CODES.API_NOT_FOUND) {
			monitoringCaptureError(error, "Lookup repository");
		}
		return false;
	}
}

/**
 * Navigate to the Repositories view with a `?connect=` query param so the
 * connect-repo flow runs on mount. Silently no-ops for missing or non-GitHub URLs.
 */
export function navigateToConnectRepo(router: Router, applicationURL: string | URL | undefined): void {
	if (!applicationURL) {
		return;
	}
	const url = typeof applicationURL === "string" ? new URL(applicationURL) : applicationURL;
	if (url.hostname !== "github.com") {
		return;
	}
	router.push({ name: "Repositories", query: { connect: url.href } });
}
